import {
  createValidator,
  required,
  minNumber,
  maxNumber,
  maxLength,
  Rules,
} from 'src/helpers/validation';
import currencyMap from 'src/helpers/currencyMap';
import { CreateFormData } from 'src/components/CreateForm/CreateForm';

export const rules: Rules<CreateFormData> = {
  targetAmount: [
    required({ message: 'Please enter the amount you want to raise' }),
    minNumber(2, {
      message: (_, values: CreateFormData) =>
        `Sorry, please make sure your target is at least ${
          currencyMap[values.targetCurrency]
        }2`,
    }),
    maxNumber(9999999, {
      message: 'Sorry, please make sure your target is achievable',
    }),
  ],
  pitchFor: [
    required({ message: 'Please explain how the money will be spent' }),
    maxLength(140, { message: 'This section has a 140 character limit' }),
  ],
  categoryId: [required({ message: 'Please select a category' })],
};

export default createValidator(rules);



// WEBPACK FOOTER //
// ./src/components/CreateForm/createFormValidator.ts